<template>
  <div class="mb-3">
    <a-radio
      radio-value="F"
      name="gender"
      :value="value"
      @input="updateValue"
      :error="error"
    >
      🙋🏻‍
    </a-radio>
    <a-radio
      label="🙋🏻‍♂️"
      radio-value="M"
      name="gender"
      :value="value"
      @input="updateValue"
      :error="error"
    />
    <a-radio
      :label="$t('m166')"
      radio-value="other"
      name="gender"
      :value="value"
      @input="updateValue"
      :error="error"
    />
    <div class="form-text-validation form-text-validation--error" v-if="error">
      <span class="text-validation">
        {{ errorMessage }}
      </span>
    </div>
  </div>
</template>

<script>
import ARadio from '@/components/ui/ARadio';

export default {
  props: {
    value: {},
    errorMessage: {
      type: String,
      default: null,
    },
    error: {
      default: false,
      type: Boolean,
    },
  },
  components: {
    ARadio,
  },
  methods: {
    updateValue(value) {
      this.$emit('input', value);
    },
  },
};
</script>
